import { parseCalendarDay } from '../../../lib/calendarDay';

/**
 * The Signals due-date colour rule, shared by the table's `due_date` cell
 * (`signalsTableConfig.tsx`) and the Signal card's meta line
 * (`SignalActionCard.tsx`, QA batch 2 unit B8 — "same `dueTone` colours as
 * the column"). Its own module so the card does not import the table
 * config (which imports `SignalDetail`, which renders the card).
 */
export type DueTone = 'overdue' | 'today' | null;

/** Local-calendar-day comparison — a due date is 'overdue' only starting the NEXT local day, 'today' on the due day itself. */
export function dueTone(dueDate: string | null, today: Date): DueTone {
  if (!dueDate) return null;
  const due = parseCalendarDay(dueDate);
  if (!due) return null;
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const dayDiff = Math.round((todayStart.getTime() - due.getTime()) / 86_400_000);
  if (dayDiff > 0) return 'overdue';
  if (dayDiff === 0) return 'today';
  return null;
}

export const DUE_TONE_CLASS: Record<'overdue' | 'today', string> = {
  overdue: 'text-content-danger dark:text-red-400',
  today: 'text-content-warning dark:text-tangerine-400',
};
